import { MotionControlsVariants } from '@polestar/component-warehouse-react/components/motion/useMotionControls';
/**
 * This can be used to start animations without doing anything visually.
 * Variants don't work if they don't have at least 1 item to animate, that is why opacity is there.
 * Because the item will animate from opacity 1 to apacity 1 it complete "instant" and continue to the next child to animate it in.
 */
export const genericMotionVariants = {
    [MotionControlsVariants.enter]: {
        opacity: 1,
        transition: {
            type: false,
        },
    },
    [MotionControlsVariants.visible]: {
        opacity: 1,
        transition: {
            when: 'beforeChildren',
        },
    },
    [MotionControlsVariants.exit]: {
        opacity: 1,
        transition: {
            when: 'afterChildren',
        },
    },
};
